function SentinelController($scope, $rootScope, $location, $http, $route, sentinelService) {
    $scope.activeView = 'visits';
    $scope.registeredGuests = [];
    $scope.activeVisitors = [];
    $scope.lastRefresh = moment().toDate();
    $scope.lastRefreshSuccessful = true;
    $scope.lastRefreshClass = [];
    $scope.lastRefreshErrorMessage = '';
    $scope.visits = [];
    $scope.selectedVisit = null;
    $scope.visitorToCheckIn = null;
    $scope.visitorToCheckOut = null;
    $scope.visitorToEdit = null;
    $scope.visitorToAddCommentTo = null;
    $scope.createModalOpen = false;
    $scope.createVideoStream = null;
    $scope.editModalOpen = false;
    $scope.editVideoStream = null;

    function onDataUpdated(newValue) {
        $scope.registeredGuests = newValue.registeredGuests;
        $scope.activeVisitors = newValue.activeVisitors;
        $scope.visits = newValue.visits;
    }

    function onLogUpdated(selectedLog) {
        if (selectedLog.sentinelProvisioned === null || selectedLog.sentinelProvisioned === undefined) {
            $route.reload();
            return;
        } else {
            sentinelService.finalize().then(function () {
                if (selectedLog.sentinelProvisioned) {
                    console.log("Initializing Sentinel service");
                    sentinelService.init($rootScope.selectedLog.id, onDataUpdated);
                } else {
                    sentinelService.getDefaultPage(selectedLog.id).then(function (route) {
                        if (route === '/sentinel') {
                            route = '/notes';
                        }
                        console.log("Routing to " + route);
                        $location.url(route);
                    });
                }
            });
        }
    }

    $scope.requestRefresh = function () {
        sentinelService.refresh();
    };

    $scope.setVisit = function (visit) {
        $scope.selectedVisit = visit;
    };

    $scope.$on('sentinel-search-criteria-changed', function () {
        sentinelService.updateSearchCriteria();
    });

    $scope.$on('sentinel-show-check-in-modal', function(event, data) {
        $scope.visitorToCheckIn = data.visitorToCheckIn;
        $('#check-in-modal').modal({backdrop: 'static', keyboard: false}, 'show');
    });

    $scope.$on('sentinel-hide-check-in-modal', function () {
        $scope.visitorToCheckIn = null;
    });

    $scope.$on('sentinel-show-check-out-modal', function(event, data) {
        $scope.visitorToCheckOut = data.visitorToCheckOut;
        $('#check-out-modal').modal({backdrop: 'static', keyboard: false}, 'show');
    });

    $scope.$on('sentinel-hide-check-out-modal', function () {
        $scope.visitorToCheckOut = null;
    });

    $scope.$on('sentinel-show-edit-modal', function(event, data) {
        $scope.editModalOpen = true;
        $scope.visitorToEdit = data.visitorToEdit;
        $('#edit-modal').modal({backdrop: 'static', keyboard: false}, 'show');
    });

    $scope.$on('sentinel-hide-edit-modal', function () {
        $scope.editModalOpen = false;
        $scope.visitorToEdit = null;
        if ($scope.editVideoStream) {
            $scope.editVideoStream.getTracks().forEach(function (track) {
                track.stop();
            });
            $scope.editVideoStream = null;
        }
    });

    $scope.$on('sentinel-edit-video-stream-set', function (event, data) {
        if ($scope.editModalOpen) {
            $scope.editVideoStream = data.stream;
        } else {
            data.stream.getTracks().forEach(function (track) {
                track.stop();
            });
            $scope.editVideoStream = null;
        }
    });

    $scope.$on('sentinel-show-comment-modal', function(event, data) {
        $scope.visitorToAddCommentTo = data.visitorToAddCommentTo;
        $('#comment-modal').modal({backdrop: 'static', keyboard: false}, 'show');
    });

    $scope.$on('sentinel-hide-comment-modal', function () {
        $scope.visitorToAddCommentTo = null;
    });

    $scope.$on('sentinel-show-create-modal', function () {
        $scope.createModalOpen = true;
    });

    $scope.$on('sentinel-hide-create-modal', function () {
        $scope.createModalOpen = false;
        if ($scope.createVideoStream) {
            $scope.createVideoStream.getTracks().forEach(function (track) {
                track.stop();
            });
            $scope.createVideoStream = null;
        }
    });

    $scope.$on('sentinel-create-video-stream-set', function (event, data) {
        if ($scope.createModalOpen) {
            $scope.createVideoStream = data.stream;
        } else {
            data.stream.getTracks().forEach(function (track) {
                track.stop();
            });
            $scope.createVideoStream = null;
        }
    });

    $scope.$on('sentinel-update-successful', function (event, data) {
        $scope.lastRefreshSuccessful = true;
        $scope.lastRefreshClass = [];
        $scope.lastRefreshErrorMessage = '';

        if (data.updateTime) {
            $scope.lastRefresh = data.updateTime.toDate();
        }
    });

    $scope.$on('sentinel-update-failed', function () {
        $scope.lastRefreshSuccessful = false;
        $scope.lastRefreshClass = ['text-danger'];
        $scope.lastRefreshErrorMessage = 'The attempt to contact the server failed. Please check your internet connection, or try again in a few minutes.';
    });

    (function () {
        $scope.$on('$destroy', sentinelService.finalize);
        onLogUpdated($rootScope.selectedLog);
    })();
}

angular.module('sentinel').controller('sentinelController', ['$scope', '$rootScope', '$location', '$http', '$route', 'sentinelService', SentinelController]);